import React, { useRef, useState, useEffect,  useCallback } from 'react';
import Measure from 'react-measure';
import styled, { css, keyframes } from 'styled-components';

import { useUserMedia } from 'hooks/useUserMedia';

const CAPTURE_OPTIONS = {
    audio: false,
    video: { facingMode: 'environment' },
};

const flashAnimation = keyframes`
  from {
    opacity: 0.75;
  }

  to {
    opacity: 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
`;

const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};
  max-height: ${({ maxHeight }) => maxHeight && `${maxHeight}px`};
  display: ${({ show }) => show ? 'block' : 'none'};
`;

const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
`;

const Video = styled.video`
  position: absolute;

  &::-webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: 20px;
  left: 20px;
  box-shadow: 0px 0px 20px 56px rgba(0, 0, 0, 0.6);
  border: 1px solid #ffffff;
  border-radius: 10px;
`;

const Flash = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  background-color: #ffffff;

  ${({ flash }) => {
    if (flash) {
      return css`
        animation: ${flashAnimation} 750ms ease-out;
      `;
    }
  }}
`;

const Button = styled.button`
  width: 75%;
  min-width: 100px;
  max-width: 250px;
  margin-top: 24px;
  padding: 12px 24px;
  background: silver;
`;

export function Camera({ onCapture, onClear, onGoBack, onContinue }) {
  const canvasRef = useRef();
  const videoRef = useRef();

  const [container, setContainer] = useState({ width: 150, height: 150 });
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isCanvasEmpty, setIsCanvasEmpty] = useState(true);
  const [isFlashing, setIsFlashing] = useState(false);
  const [image, setImage] = useState(null);

  const mediaStream = useUserMedia(CAPTURE_OPTIONS);
  const [aspectRatio, calculateRatio] = useCardRatio(1.586);
  const offsets = useOffsets(
    videoRef.current && videoRef.current.videoWidth,
    videoRef.current && videoRef.current.videoHeight,
    container.width,
    container.height
  );

  useEffect(() => {
    if (mediaStream && videoRef.current && !videoRef.current.srcObject) {
      videoRef.current.srcObject = mediaStream;
    }
  }, [mediaStream, videoRef.current])


  console.log({mediaStream, canvasRef, videoRef})

  function handleResize(contentRect) {
    console.log({contentRect})
    setContainer({
      width: contentRect.bounds.width,
      height: Math.round(contentRect.bounds.width / aspectRatio)
    });
  }

  function handleCanPlay() {
    console.log('playing')
    calculateRatio(videoRef.current.videoHeight, videoRef.current.videoWidth);
    setIsVideoPlaying(true);
    videoRef.current.play();
  }

  function handleCapture() {
    const context = canvasRef.current.getContext('2d');

    context.drawImage(
      videoRef.current,
      offsets.x,
      offsets.y,
      container.width,
      container.height,
      0,
      0,
      container.width,
      container.height
    );

    canvasRef.current.toBlob(blob => onCapture(blob), 'image/jpeg', 1);
    setIsCanvasEmpty(false);
    setIsFlashing(true);
  }

  function handleClear() {
    if (!image) {
      const context = canvasRef.current.getContext('2d');
      context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      setIsCanvasEmpty(true);
    } else {
      setImage(null)
    }
    onClear();
  }

  console.log({container, isVideoPlaying, isCanvasEmpty})

  const handleChooseFile = () => {
    const eleInput = document.createElement('input');
    eleInput.type = 'file';
    eleInput.style.display = 'none';
    eleInput.accept = 'image/*';
    eleInput.onchange = (e) => {
      const file = e.target.files[0];

      if (file) {
        onCapture(file)
        
        setImage( URL.createObjectURL(file))
        setIsCanvasEmpty(true);
      }
    };
    eleInput.click();
  }

  if (!mediaStream) {
    return <div>
        Cargando...
      </div>;
  }

  return (
    <Measure bounds onResize={handleResize}>
      {({ measureRef }) => (
        <Wrapper>
        { image  &&
              <img src={image} style={{width: 450, height: 300}} /> }
          <Container
            ref={measureRef}
            maxHeight={videoRef.current && videoRef.current.videoHeight}
            maxWidth={videoRef.current && videoRef.current.videoWidth}
            style={{
              height: `${container.height}px`
            }}
            show={!image}
          >
            <Video
              ref={videoRef}
              hidden={!isVideoPlaying}
              onCanPlay={handleCanPlay}
              autoPlay
              playsInline
              muted
              style={{
                top: `-${offsets.y}px`,
                left: `-${offsets.x}px`
              }}
            />

            <Overlay hidden={!isVideoPlaying} />
          
            <Canvas
              ref={canvasRef}
              width={container.width}
              height={container.height}
            /> 
        
            <Flash
              flash={isFlashing}
              onAnimationEnd={() => setIsFlashing(false)}
            />
          </Container>
        
          {isVideoPlaying && (
            <div className="p-2">
             {onGoBack && <button className="btn btn-secondary mx-2" onClick={onGoBack}>
                Confirmar
              </button>}
              <button className="btn btn-primary mx-3" onClick={isCanvasEmpty && !image ? handleCapture : handleClear}>
                {isCanvasEmpty && !image ? <i className="fas fa-camera text-light"></i> : <i className="fas fa-undo text-light"></i>}
                {isCanvasEmpty && !image ? ' Tomar foto' : ' Tomar otra foto'}
              </button>
              {/* <button className="btn btn-secondary" onClick={isCanvasEmpty ? handleCapture : handleClear}>
                Subir imagen
              </button> */}
              {/* <button className="btn btn-secondary" onClick={onContinue}>
                Subir
              </button> */}
            </div>
         
          )}
          {isVideoPlaying && (
            <div className="p-1 text-primary hover_text-decoration-underline" onClick={handleChooseFile}>
              <small>Subir imagen</small>
            </div>
          )}
        </Wrapper>
        )}
     </Measure>
  );
}

export function useCardRatio(initialRatio) {
  const [aspectRatio, setAspectRatio] = useState(initialRatio);

  const calculateRatio = useCallback((height, width) => {
    if (height && width) {
      const isLandscape = height <= width;
      const ratio = isLandscape ? width / height : height / width;

      setAspectRatio(ratio);
    }
  }, []);

  return [aspectRatio, calculateRatio];
}

export function useOffsets(vWidth, vHeight, cWidth, cHeight) {
  const [offsets, setOffsets] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (vWidth && vHeight && cWidth && cHeight) {
      const x = vWidth > cWidth
        ? Math.round((vWidth - cWidth) / 2)
        : 0;

      const y = vHeight > cHeight
        ? Math.round((vHeight - cHeight) / 2)
        : 0;

      setOffsets({ x, y });
    }
  }, [vWidth, vHeight, cWidth, cHeight]);

  return offsets;
}